export const extractProperty = (object: any, propertyString: string | undefined) =>
  propertyString?.split('.')?.reduce((o, i, _, arr) => {
    if (o[i] === undefined) {
      arr.splice(1);
    }
    return o[i];
  }, object);
